import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnuydu44kp: FaireProductEntity = {
  token: "p_bnuydu44kp",
  type: "product",
  name: "Oyster Food-Shaped Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/b9f88b8bb5e926d8a7a9aa7f8ed2c2dcb5dc89a62675e0b85b92a61d57560aba.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description: "Inspired by coastal dinners, raw bars, and notes written with intention. This oyster shaped sticky note is perfect for reminders, lists, lunch notes, or small daily plans.\n\nDesigned for stationery lovers, coastal creatives, and food-obsessed gift shoppers, Oyster Notes make daily desk essentials feel special without trying too hard. \n\nGood to know:\n\n * Stick & restick anywhere \n * Thick sticky pad with 50 sheets \n * Measures roughly 3\"x3\" \n * Packaged on a thick backing card and wrapped in a cellophane sleeve. \n * 100% recyclable 🍅 ",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:09.861Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
